interface Props {
  message?: string;
}

export function Loading({ message = 'Finding your advisor…' }: Props) {
  return (
    <div className="loading-state">
      <div className="loading-spinner" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className="loading-message">{message}</p>
    </div>
  );
}
